export function descriptionFormatter({ data: { description } }): string {
  if (description) {
    const descriptionSplit = description.split('\n').map(d => {
      const trimedD = d.trim();
      return trimedD.slice(-1) === ',' ? trimedD.slice(0, -1) : trimedD;
    });
    const firstLine = descriptionSplit[0]
      .toLowerCase()
      .replace(/(^|[^a-z0-9-'"])([a-z])/g, function(m, m1, m2, p) {
        return m1 + m2.toUpperCase();
      });
    return [firstLine, ...descriptionSplit.slice(1)]
      .map(line => line.trim())
      .filter(line => line.length)
      .join(', ');
  } else {
    return '';
  }
}
